import React from "react";
import * as Cookies from "es-cookie";
import SalesAdminDashboard from "../components/SalesAdmin/SalesAdminDashboard";

export default function SalesAdminPage() {
  const currentInst = parseInt(Cookies.get("institutionid"));
  
  // Strict restriction: If user is logged into another institute, block access.
  if (currentInst && currentInst !== 51) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
          fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
        }}
      >
        <div
          style={{
            background: "rgba(30, 41, 59, 0.7)",
            backdropFilter: "blur(16px)",
            border: "1px solid rgba(255, 255, 255, 0.1)",
            borderRadius: 24,
            padding: "48px 36px",
            maxWidth: 480,
            width: "100%",
            textAlign: "center",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
          }}
        >
          <div
            style={{
              width: 72,
              height: 72,
              borderRadius: "50%",
              background: "rgba(239, 68, 68, 0.15)",
              border: "1px solid rgba(239, 68, 68, 0.3)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 24px",
              fontSize: 32,
            }}
          >
            🔒
          </div>
          <span
            style={{
              background: "rgba(239, 68, 68, 0.2)",
              color: "#FCA5A5",
              border: "1px solid rgba(239, 68, 68, 0.3)",
              padding: "4px 12px",
              borderRadius: 20,
              fontSize: 12,
              fontWeight: 700,
              letterSpacing: 0.5,
              textTransform: "uppercase",
              display: "inline-block",
              marginBottom: 16,
            }}
          >
            Access Restricted
          </span>
          <h2
            style={{
              color: "#FFFFFF",
              fontSize: 24,
              fontWeight: 800,
              margin: "0 0 12px",
              letterSpacing: "-0.5px",
            }}
          >
            Institute 51 Exclusive
          </h2>
          <p
            style={{
              color: "#94A3B8",
              fontSize: 14,
              lineHeight: 1.6,
              margin: "0 0 28px",
            }}
          >
            The Sales Admin Portal is strictly restricted to <b>Institute 51</b>. 
            Your current logged-in session belongs to Institute <b>#{currentInst}</b>.
          </p>
          <button
            onClick={() => window.history.back()}
            style={{
              background: "linear-gradient(135deg, #4F46E5 0%, #4338CA 100%)",
              color: "#FFFFFF",
              border: "none",
              borderRadius: 12,
              padding: "12px 28px",
              fontSize: 14,
              fontWeight: 700,
              cursor: "pointer",
              boxShadow: "0 10px 15px -3px rgba(79, 70, 229, 0.3)",
              transition: "all 0.2s ease",
            }}
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return <SalesAdminDashboard />;
}

